export enum RequestSyncStatus {
  /// <summary>
  /// Raspoređivanje
  /// </summary>
  Deployment = 1,
  /// <summary>
  /// Upisan u e-Maticu
  /// </summary>
  EnrolledInMatica = 2,
  /// <summary>
  /// Ručni unos
  /// </summary>
  ManualInput = 3,
}
